export enum NotificationsType {
  GAME_INVITE = 'game_invite',
  GAME_INVITE_ACCEPTED = 'game_invite_accepted',
  GAME_INVITE_REJECTED = 'game_invite_rejected',
  HEADS_UP = 'heads_up',
}
